import Icon from '../components/Icon.vue'

Icon.register({
  indent: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M27.3 363.3c-10 10-27.3 3-27.3-11.3v-192c0-14.2 17.3-21.3 27.3-11.3l96 96c2.6 2.6 4.7 7.7 4.7 11.3 0 3.7-2.1 8.7-4.7 11.3zM432 416c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-416c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h416zM435.2 288c7.1 0 12.8 5.7 12.8 12.8v0 38.3 0c0 7.1-5.7 12.8-12.8 12.8h0-230.3 0c-7.1 0-12.8-5.7-12.8-12.8v0-38.3 0c0-7.1 5.7-12.8 12.8-12.8h0 230.3zM435.2 160c7.1 0 12.8 5.7 12.8 12.8v0 38.3 0c0 7.1-5.7 12.8-12.8 12.8h0-230.3 0c-7.1 0-12.8-5.7-12.8-12.8v0-38.3 0c0-7.1 5.7-12.8 12.8-12.8h0 230.3zM432 32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-416c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h416z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/indent.js
// module id = 1488
// module chunks = 0